<template>
  <div class="app-footer">
    <div class="container">© {{ currentYear }} Pamarin</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.app-footer .container {
  font-size: 90%;
}
</style>